const config = {
  // LOCAL STORAGE KEYS
  lang: "_lang",
  localLang: "lang",
  // COOKIES_KEYS

  // APP Name
  appName: "Circassian Tribal Council",

  API_URL: "",
  baseUrl: "",
  filesBaseUrl: "",
};

const environment = {
  ...config,
};

export default environment;
